import React, { useEffect } from 'react';
import { HeaderType } from '../components/Title';
import { MenuItem } from '../components/Menu';
import { FaUser } from "react-icons/fa";
import { useAuth } from '../auth/AuthProvider';
import { MdDriveFileRenameOutline } from "react-icons/md";
import { TfiEmail } from "react-icons/tfi";
import { FaPhoneAlt, FaIdBadge } from "react-icons/fa";
import { IoCalendar } from "react-icons/io5";
export const ProfileHeader = (): HeaderType => {
  return {
    title: 'Perfil',
    subtitle: `Olá ${useAuth().profile?.nome?.split(' ')[0]}`,
    icon: <FaUser size={40} />
  }
}

export const ProfileMenu = (): MenuItem => {
  return {
    icon: <FaUser size={32} />,
    label: 'PERFIL'
  }
}

const Profile: React.FC = () => {
  const authenticator = useAuth()
  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <MdDriveFileRenameOutline />
        <strong style={{ marginLeft: 5, marginRight: 10 }}>
          Nome:
        </strong>
        {authenticator.profile?.nome}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <TfiEmail />
        <strong style={{ marginLeft: 5, marginRight: 10 }}>
          Email:
        </strong>
        {authenticator.profile?.email}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <FaPhoneAlt />
        <strong style={{ marginLeft: 5, marginRight: 10 }}>
          Telefone:
        </strong>
        {authenticator.profile?.celular}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <FaIdBadge />
        <strong style={{ marginLeft: 5, marginRight: 10 }}>
          CPF:
        </strong>
        {authenticator.profile?.cpf}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <IoCalendar />
        <strong style={{ marginLeft: 5, marginRight: 10 }}>
          Data de Cadastro:
        </strong>
        {new Date(authenticator.profile?.user?.date_joined).toLocaleString()}
      </div>

      {/* Placa:
      { authenticator.profile?.placa }
      <br />
      Modelo do Carro:
      { authenticator.profile?.modeloCarro }
      <br />
      Cidade:
      { authenticator.profile?.cidade }
      <br />
      Estado:
      { authenticator.profile?.estado }
      <br />
      País:
      { authenticator.profile?.pais }
      <br />
      CEP:
      { authenticator.profile?.cep }
      <br />
      Endereço:
      { authenticator.profile?.endereco }
      <br />
      Número:
      { authenticator.profile?.numero }
      <br />
      Complemento:
      { authenticator.profile?.complemento }
      <br />
      Bairro:
      { authenticator.profile?.bairro }
      <br />
      Data de Nascimento:
      { authenticator.profile?.dataNascimento }
      <br />
      Gênero:
      { authenticator.profile?.genero }
      <br />
      Estado Civil:
      { authenticator.profile?.estadoCivil }
      <br />
      Profissão:
      { authenticator.profile?.profissao }
      <br />
      Renda Mensal:
      { authenticator.profile?.rendaMensal }
      <br />
      Nacionalidade:
      { authenticator.profile?.nacionalidade }
      <br />
      Documento de Identificação:
      { authenticator.profile?.documentoIdentificacao }
      <br />
      Órgão Emissor:
      { authenticator.profile?.orgaoEmissor }
      <br />
      Data de Emissão:
      { authenticator.profile?.dataEmissao }
      <br />
      Data de Validade:
      { authenticator.profile?.dataValidade }
      <br />
      Nome da Mãe:
      { authenticator.profile?.nomeMae }
      <br />
      Nome do Pai:
      { authenticator.profile?.nomePai }
      <br /> */}
    </div>
  );
};

export default Profile;